import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaTotalAVencer = (): TabelaColuna => ({
  Chave: 'TotalAVencer',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.moeda(linha.TotalAVencer)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Total A Vencer</div>
})
